import api from "../api/api";
import { Invoice, InvoiceCreate, InvoiceUpdate } from "../types";

export const getInvoices = async () => {
  const res = await api.get("/invoices");
  return res.data;
};

export const getInvoice = async (id: number) => {
  const res = await api.get(`/invoices/${id}`);
  return res.data;
};

export const createInvoice = async (data: InvoiceCreate) => {
  const res = await api.post("/invoices", data);
  return res.data;
};

export const updateInvoice = async (id: number, data: InvoiceUpdate) => {
  const res = await api.put(`/invoices/${id}`, data);
  return res.data;
};

export const markInvoiceAsPaid = async (id: number) => {
  const res = await api.post(`/invoices/${id}/mark-paid`);
  return res.data;
};

export const generateInvoicePDF = async (id: number) => {
  const res = await api.post(`/invoices/${id}/generate-pdf`);
  return res.data;
};

export const downloadInvoicePDF = async (id: number) => {
  const res = await api.post(`/invoices/${id}/download-pdf`);
  return res.data;
};

export const sendInvoiceEmail = async (id: number, emailData: {
  to_email: string;
  subject?: string;
  message?: string;
}) => {
  const res = await api.post(`/invoices/${id}/send-email`, emailData);
  return res.data;
};

// Service object for backward compatibility
export const invoiceService = {
  getInvoices,
  getInvoice,
  createInvoice,
  updateInvoice,
  markInvoiceAsPaid,
  generatePDF: generateInvoicePDF,
  downloadPDF: downloadInvoicePDF,
  sendEmail: sendInvoiceEmail
}; 